import React from "react";
import styled from "styled-components";
import MortgageDetailForm from "./MortgageDetailForm";
import Costs from "../ClosingCosts/Costs";
import useLanguage from "../../../../utilities/useLanguage";
import { getTranslation } from "../../translations";

const Title = styled.h2`
    font-size: 2.111rem;
    font-weight: 400;
    font-family: "Sentinel A", "Sentinel B", serif;
`;

export default (props) => {
    const { formLoading, disclaimer, employee, emailSent, onEmailFormChange, insurance, loanLabel, loanType, otherDetailsHeader, otherDetailsLabel, showEmailForm, spinner, values, taxes, labels, onChange, dropdownState, show, details, dirty, submitForm, emailValues, sendEmail, loanName, loanFullName, feeDivClass, errorValue, referrerId, firstTimeLimit, maxLTVRates } = props;
    const { lang } = useLanguage()

    const detailProps = {
        submitForm,
        formLoading,
        onChange,
        values,
        labels,
        dropdownState,
        show,
        errorValue,
        firstTimeLimit,
        loanFullName,
        loanType,
        maxLTVRates,
    };

    const closingProps = {
        details,
        employee,
        disclaimer,
        loanLabel,
        taxes,
        insurance,
        feeDivClass,
        sendEmail,
        show,
        dirty,
        emailValues,
        emailSent,
        onChange,
        loanName,
        spinner,
        showEmailForm,
        onEmailFormChange,
        otherDetailsLabel,
        otherDetailsHeader,
        referrerId
    };

    return (
        <div className="container">
            <div>
                <Title className="text-primary text-center">{getTranslation(lang).advancedDetails}</Title>
                <MortgageDetailForm {...detailProps} />
                <Costs {...closingProps} />
            </div >
        </div >
    );
};